export enum RepresentationType {
  FLAT_GEOBUFF = 'flatGeoBuf',
  IMAGE = 'image',
  RAYOS = 'rayos',
  STORM = 'storm',
  PDF = 'pdf',
  SVG = 'svg',
  STATIONS = 'stations',
  HOTSPOTS = 'hotspots',
  TILE_LAYER = 'tileServer',
  STREAMLINES = 'streamlines',
  SYMBOL_MAP = 'weather-json'
}
